import React from "react";
import Link from "next/link";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { ReactSVG } from "react-svg";
import styles from "./hero.module.scss";

export const ElearningDetailHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <div className="wrapper">
          <div className={styles.heading_wrapper}>
            <h2 className={styles.title}>
              The Complete IELTS Training Program
            </h2>
            <p className={styles.sub_text}>
              A 20 hours live IELTS training by our expert, where you can start
              learning IELTS from scratch. The course will help you to get
              in-depth knowledge of all the modules, techniques to solve
              different types of questions and tips to solve them in a given
              time limit. After this course, you will feel confident enough to
              take up your IELTS exam and hit your target score and finally
              start up your abroad journey.Here are some of the highlights of
              our Rs.4999 course:
            </p>
          </div>

          {/* <div className={styles.short_info_wrapper}>
            <ul>
              <li>
                <div className={styles.stars}>
                  <AiFillStar />
                  <AiFillStar />
                  <AiFillStar />
                  <AiFillStar />
                  <AiOutlineStar />
                </div>
                <span className={styles.info_text}>4.0 (1835)</span>
              </li>
              <li>
                <ReactSVG
                  src="/assets/images/elearning/group.svg"
                  className={styles.info_icon}
                />
                <span className={styles.info_text}>3045 Enroled Student</span>
              </li>

              <li>
                <ReactSVG
                  src="/assets/images/elearning/globe.svg"
                  className={styles.info_icon}
                />
                <span className={styles.info_text}>4.0 (1835)</span>
              </li>
            </ul>
          </div> */}

          {/* <div className={styles.info_price}>
            <span className={styles.info_price_prev}>
              Course Fee ₹ 10,000/-
            </span>

            <span className={`${styles.info_price_now} color-orange`}>
              Launch Offer free
            </span>
          </div> */}

          {/* <div className={styles.btn_wrapper}>
            <Link  legacyBehavior href="#">
              <a className={`btn btn-secondary btn-xl`}>Take This Course</a>
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ElearningDetailHero;
